module.exports = __webpack_public_path__ + "static/media/bordered-tick.379f41ad.svg";